import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PermisiuniActiuniAddPayload, PermisiuniActiuniUpdatePayload } from './permisiuni-actiuni.interface';

@Injectable({
  providedIn: 'root'
})
export class PermisiuniActiuniService {
  private basePath = environment.interop.basePath;
  private getPermisiuniActiuneDT = this.basePath + environment.interop.urbanism.nomenclatoare.permissionActions.getPermissionActionsDT;
  private token!: string;
  private httpOptions: any;
  private storePermisiuniActiuniURL = this.basePath + environment.interop.urbanism.nomenclatoare.permissionActions.storePermissionAction;
  private updateStorePermisiuniActiuni = this.basePath + environment.interop.urbanism.nomenclatoare.permissionActions.putPermissionAction;
  private deletePermisiuniActiuni = this.basePath + environment.interop.urbanism.nomenclatoare.permissionActions.deletePermissionAction;
  private getPermisiuniActiuniActive = this.basePath + environment.interop.urbanism.nomenclatoare.permissionActions.getPermissionActionsActive;
  private getPermisiuniActiuniPublic = this.basePath + environment.interop.urbanism.nomenclatoare.permissionActions.getPermissionActionsActivePublic;

  constructor(private http: HttpClient) {}

  getPermisiuniActiuniDT() {
    return this.http.get(this.getPermisiuniActiuneDT, this.httpOptions);
  }

  addPermisiuniActiune(permisiuniActiune: PermisiuniActiuniAddPayload) {
    return this.http.post(this.storePermisiuniActiuniURL, permisiuniActiune, this.httpOptions);
  }

  updatePermisiuniActiune(permisiuniActiune: PermisiuniActiuniUpdatePayload) {
    return this.http.put(this.updateStorePermisiuniActiuni, permisiuniActiune, this.httpOptions);
  }

  deletePermisiuniActiune(permisiuniActiuneId: number) {
    return this.http.delete(this.deletePermisiuniActiuni + permisiuniActiuneId);
  }

  getActivePermisiuniActiuni() {
    return this.http.get(this.getPermisiuniActiuniActive, this.httpOptions);
  }

  getPublicPermisiuniActiuni() {
    return this.http.get(this.getPermisiuniActiuniPublic, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
